import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/schedule/page.js");
